import utility from "@/utility";

export const clearDirty = (commit, formKeys = []) => {
  if (formKeys.length > 0) {
    commit(
      "form/changeDirty",
      formKeys.map((formKey) => {
        return {
          key: formKey,
          isDirty: false
        };
      }),
      {
        root: true
      }
    );
  } else {
    commit("form/clearDirty", null, { root: true });
  }
};

const setOptionRefreshTrigger = (name, store) => {
  if (store.state[name].options) {
    store.commit(`${name}/options/setRefreshTrigger`, {
      root: true
    });
  }
};

export const options = (name) => {
  return {
    namespaced: true,
    state: {
      options: [],
      loading: false,
      loaded: false
    },
    mutations: {
      loading(state) {
        state.loading = true;
      },
      succeeded(state, { options }) {
        state.options = options;
        state.loading = false;
        state.loaded = true;
      },
      failed(state) {
        state.loading = false;
        state.loaded = false;
      },
      setRefreshTrigger(state) {
        state.loaded = false;
      },
      initialize(state) {
        state.options = [];
        state.loading = false;
        state.loaded = false;
      }
    },
    actions: {
      index({ commit, getters }, params = undefined) {
        // if (getters.isLoaded || getters.isLoading) {
        //   return Promise.resolve();
        // }

        commit("loading");

        return new Promise((resolve, reject) => {
          if(name === 'product_medium_categories' || name === 'keywords' || name === 'biz_medium_categories' || name === 'medium_locations' || name === 'reminder_templates'){
            if(params) {
              this.$axios
                .get(`/options/${name}/${params}`, {
                })
                .then((response) => {
                  commit("succeeded", {
                    options: response.data.data
                  });

                  resolve();
                })
                .catch((error) => {
                  commit("failed");

                  reject(error);
                });
            }
          } else {
            this.$axios
              .get(`/options/${name}`, {
                params
              })
              .then((response) => {
                commit("succeeded", {
                  options: response.data.data
                });

                resolve();
              })
              .catch((error) => {
                commit("failed");

                reject(error);
              });
          }
        });
      }
    },
    getters: {
      options(state) {
        return state.options || [];
      },
      isLoading(state) {
        return state.loading;
      },
      isLoaded(state) {
        return state.loaded;
      }
    }
  };
};

export const list = (name) => {
  return {
    namespaced: true,
    state: {
      entities: [],
      total: 0,
      page: 1,
      perPage: 20, //変えられるようにする
      sort: {},
      loading: false,
      loaded: false,
      processing: false,
      error: false,
      errorMessages: [],
      recipeNum: null,
      maxRecipeNum: null,
      productNum: null,
      notRead: 0,
      selected: [],
      allSelected: false
    },
    mutations: {
      loading(state) {
        state.loading = true;
      },
      succeeded(state, { entities, total, page, recipeNum = null, maxRecipeNum = null, notRead = 0, productNum = null }) {
        state.entities = entities;
        state.total = total;
        state.page = page;
        state.loading = false;
        state.loaded = true;
        state.error = false;
        state.recipeNum = recipeNum;
        state.maxRecipeNum = maxRecipeNum;
        state.notRead = notRead;
        state.productNum = productNum;
      },
      failed(state, { error }) {
        state.loading = false;
        state.loaded = true;

        let status = null;
        let errorMessages = [];

        if (error.response) {
          status = error.response.status;
          errorMessages = error.response.data;
        } else {
          status = error.status || null;
          errorMessages = [];
        }

        switch (status) {
          case 423: //TODO: 仮 (レシピ最大公開数を超えたエラー)
　　　　　　　break;

          case 422:
            state.errorMessages = errorMessages;
            break;

          case 401:
            // 何もしない
            break;

          default:
            state.error = true;
            break;
        }
      },
      processing(state) {
        state.processing = true;
      },
      processed(state) {
        state.processing = false;
      },
      setSort(state, sort = {}) {
        state.sort = {
          ...sort,
          direction:
            state.sort.field === sort.field && state.sort.direction === "asc"
              ? "desc"
              : "asc"
        };
      },
      setPerPage(state, {perPage}) {
        state.perPage = perPage;
      },
      updateSelected(state, {selected}) {
        state.selected = selected;
      },
      updateAllSelected(state, {allSelected}) {
        state.allSelected = allSelected;
      }
    },
    actions: {
      index(
        { commit, getters },
        { page, filters = [], sort = {}, user_id = "", extra = {} }
      ) {
        commit("loading");

        let params = {
          page,
          perPage: getters.perPage,
          filters: JSON.stringify(filters),
          sorts:
            Object.keys(sort).length > 0
              ? JSON.stringify([sort])
              : undefined,
          user_id
        };

        // 追加のパラメータがあれば追加
        if (Object.keys(extra).length) {
          params.extra = extra;
        }

        return new Promise((resolve, reject) => {
          this.$axios
            .get(`/${name}`, {
              params: params
            })
            .then((response) => {
              commit("succeeded", {
                entities: response.data.data,
                total: response.data.total,
                page: page,
                recipeNum: response.data.recipeNum,
                maxRecipeNum: response.data.maxRecipeNum,
                notRead: response.data.notRead,
                productNum: response.data.productNum
              });

              resolve();
            })
            .catch((error) => {
              commit("failed", { error });

              reject(error);
            });
        });
      },
      destroy({ commit }, { ids }) {
        const store = this;

        commit("processing");

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .delete(`/${name}`, {
              params: {
                ids
              }
            }) // delete
            .then(() => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              utility.$message({
                type: "success",
                message: "削除しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              if (name === 'templates') {
                utility.$alert(error.response.data.message || error.message, "", {
                  type: "warning",
                  center: false,
                  dangerouslyUseHTMLString:true,
                  confirmButtonText: '閉じる'
                });
              }

              reject(error);
            });
        });
      },
      publish({ commit }, { ids, status, reserve, date, makerIds = [] }) {
        const store = this;

        commit("processing");

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .put(`/${name}/publish`, {
                ids,
                status,
                reserve,
                date,
                makerIds
            }) // delete
            .then(() => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              utility.$message({
                type: "success",
                message: reserve ?
                  (status === 1 ? "公開状態への更新を予約しました" : "非公開状態への更新を予約しました") :
                  (status === 1 ? "公開状態に更新しました" : "非公開状態に更新しました"),
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      },
      cancelPublish({ commit }, { ids }) {
        const store = this;

        commit("processing");

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .delete(`/${name}/publish/cancel`, {
              params: {
                ids
              }
            }) // delete
            .then(() => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              utility.$message({
                type: "success",
                message: "公開状態の更新予約を取り消しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      },
      changePerPage({ commit }, { perPage }) {
        commit("setPerPage", {perPage});
      }
    },
    getters: {
      entities(state) {
        return state.entities || [];
      },
      total(state) {
        return state.total || 0;
      },
      recipeNum(state) {
        return state.recipeNum || 0;
      },
      maxRecipeNum(state) {
        return state.maxRecipeNum || null;
      },
      productNum(state) {
        return state.productNum || 0;
      },
      notRead(state) {
        return state.notRead || 0;
      },
      page(state) {
        return state.page || 1;
      },
      perPage(state) {
        return state.perPage || 10;
      },
      pageLength(state) {
        if (state.total > 0) {
          return Math.ceil(state.total / state.perPage);
        } else {
          return 0;
        }
      },
      sort(state) {
        return state.sort || {};
      },
      isLoading(state) {
        return state.loading;
      },
      isLoaded(state) {
        return state.loaded;
      },
      isProcessing(state) {
        return state.processing;
      },
      selected(state) {
        return state.selected || [];
      },
      allSelected(state) {
        return state.allSelected;
      }
    }
  };
};

export const entity = (name, initialEntity) => {
  return {
    namespaced: true,
    state: {
      entity: null,
      loading: false,
      loaded: false,
      processing: false,
      error: false,
      errorMessages: [],
      fromConfirm: false
    },
    mutations: {
      initialize(state) {
        state.entity = { ...initialEntity };
        state.loading = false;
        state.loaded = false;
        state.processing = false;
        state.error = false;
        state.errorMessages = [];
        state.fromConfirm = false;
      },
      loading(state) {
        state.loading = true;
        state.loaded = false;
      },
      succeeded(state, payload) {
        state.entity = payload.entity;
        state.loading = false;
        state.loaded = true;
        state.error = false;
        state.errorMessages = [];
      },
      confirm(state, payload) {
        state.entity = {
          ...state.entity,
          ...payload.inputEntity
        };
        state.fromConfirm = false;
      },
      backFromConfirm(state) {
        state.fromConfirm = true;
      },
      failed(state, { error }) {
        state.loading = false;
        state.loaded = true;
        state.fromConfirm = false;

        let status = null;
        let errorMessages = [];

        if (error.response) {
          status = error.response.status;
          errorMessages = error.response.data;
        } else {
          status = error.status || null;
          errorMessages = [];
        }

        switch (status) {
          case 422:
            state.errorMessages = errorMessages;
            break;

          case 401:
            // 何もしない
            break;

          default:
            state.entity = null;
            state.error = true;
            break;
        }
      },
      processing(state) {
        state.processing = true;
      },
      processed(state) {
        state.processing = false;
      }
    },
    actions: {
      show({ commit }, { pk }) {
        commit("loading");

        return new Promise((resolve, reject) => {
          this.$axios // axios
            .get(`/${name}/${pk}`) // get
            .then((response) => {
              commit("succeeded", {
                entity: response.data.data
              });

              resolve();
            })
            .catch((error) => {
              commit("failed", { error });

              reject(error);
            });
        });
      },
      store({ commit }, { storedEntity, path = "", formKeys = [] }) {
        const store = this;

        commit("processing");
        let url = `/${name}`;
        if (path) {
          url += `/${path}`;
        }

        return new Promise((resolve, reject) => {
          store.$axios
            .post(url, storedEntity)
            .then((response) => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              clearDirty(commit, formKeys);

              utility.$message({
                type: "success",
                message: "登録しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve(response);
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      },
      update({ commit }, { pk, path = "", updatedEntity, formKeys = [] }) {
        const store = this;

        commit("processing");
        let url = `/${name}/${pk}`;
        if (path) {
          url += `/${path}`;
        }

        return new Promise((resolve, reject) => {
          store.$axios
            .put(url, updatedEntity)
            .then(() => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              clearDirty(commit, formKeys);

              utility.$message({
                type: "success",
                message: "更新しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      },
      destroy({ commit }, { ids, destroyEntity = undefined }) {
        const store = this;

        commit("processing");

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .delete(`/${name}`, {
              params: {
                ids
              }
            }) // delete
            .then(() => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              utility.$message({
                type: "success",
                message: "削除しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              if (name === 'templates') {
                utility.$alert(error.response.data.message || error.message, "", {
                  type: "warning",
                  center: false,
                  dangerouslyUseHTMLString:true,
                  confirmButtonText: '閉じる',
                  onClose: () => {
                    reject(error);
                  }
                });
              } else {
                reject(error);
              }
            });
        });
      },
      confirm({ commit }, { inputEntity, formKeys = [] }) {
        const store = this;

        commit("processing");

        return new Promise((resolve) => {
          commit("processed");
          commit("confirm", {
            inputEntity
          });
          clearDirty(commit, formKeys);

          setOptionRefreshTrigger(name, store);

          resolve();
        });
      },
      backFromConfirm({ commit }) {

        commit("processing");

        return new Promise((resolve) => {
          commit("processed");

          clearDirty(commit, []);

          commit("backFromConfirm");

          resolve();
        });
      },
      restore({ commit }, { ids}) {
        const store = this;

        commit("processing");

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .put(`/${name}`, {
                ids
            }) // delete
            .then(() => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              utility.$message({
                type: "success",
                message: "復活しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      },
      changePassword({ commit }, { id = null }) {
        const store = this;

        commit("processing");

        let path = `/${name}/change_password`;
        if(id != null){
          path += `/${id}`;
        }

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .put(path)
            .then(() => {
              commit("processed");

              setOptionRefreshTrigger(name, store);

              utility.$message({
                type: "success",
                message: "再発行したパスワードをメールで送信しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      }
    },
    getters: {
      initialEntity() {
        return { ...initialEntity };
      },
      entity(state) {
        return state.entity || {};
      },
      isLoading(state) {
        return state.loading;
      },
      isLoaded(state) {
        return state.loaded;
      },
      isProcessing(state) {
        return state.processing;
      },
      error(state) {
        return state.error;
      },
      errorMessages(state) {
        return state.errorMessages || [];
      },
      isFromConfirm(state) {
        return state.fromConfirm;
      }
    }
  };
};

export const csv = (name) => {
  return {
    namespaced: true,
    state: {
      entities: [],
      total: 0,
      loading: false,
      loaded: false,
      processing: false,
      error: false,
      errorMessages: [],
      file: null,
      open: false,
      selected: [],
      allSelected: false,
    },
    mutations: {
      loading(state) {
        state.loading = true;
      },
      succeeded(state, { entities, total }) {
        state.entities = entities;
        state.total = total;
        state.loading = false;
        state.loaded = true;
        state.error = false;
      },
      uploaded(state, { file }) {
        state.file = file;
        state.loading = false;
        state.loaded = true;
        state.error = false;
        state.errorMessages = [];
      },
      failed(state, { error }) {
        state.loading = false;
        state.loaded = true;

        let status = null;
        let errorMessages = [];

        if (error.response) {
          status = error.response.status;
          errorMessages = error.response.data;
        } else {
          status = error.status || null;
          errorMessages = [];
        }

        switch (status) {
          case 422:
            state.errorMessages = errorMessages;
            break;

          case 401:
            // 何もしない
            break;

          default:
            state.error = true;
            break;
        }
      },
      processing(state) {
        state.processing = true;
      },
      processed(state) {
        state.processing = false;
      },
      open(state) {
        state.open = true;
      },
      close(state) {
        state.open = false;
        state.file = null;
        state.processing = false;
        state.error = false;
        state.errorMessages = [];
      },
      updateFile(state, { file }) {
        state.file = file;
      },
      clear(state) {
        state.entities = [];
        state.total = 0;
        state.file = null;
      },
      updateSelected(state, {selected}) {
        state.selected = selected;
      },
      updateAllSelected(state, {allSelected}) {
        state.allSelected = allSelected;
      }
    },
    actions: {
      index(
        { commit, getters },
        { makerId, filters = [], sort = {} }
      ) {
        commit("loading");

        return new Promise((resolve, reject) => {
          this.$axios
            .get(`/maker/${name}/${makerId}`, {
              params: {
                filters: JSON.stringify(filters),
                sorts:
                  Object.keys(sort).length > 0
                    ? JSON.stringify([sort])
                    : undefined,
                page: 1,
                perPage: 99999,
              }
            })
            .then((response) => {
              commit("succeeded", {
                entities: response.data.data,
                total: response.data.total
              });

              resolve();
            })
            .catch((error) => {
              commit("failed", { error });

              reject(error);
            });
        });
      },
      upload(
        { commit, getters },
        { formData, zip = false }
      ) {
        commit("loading");

        return new Promise((resolve, reject) => {
          this.$axios
            .postUpload(zip ? "zip" : "file", formData)
            .then(response => {
              commit("uploaded", {
                file: response.data.data
              });
              resolve(response);
            })
            .catch((error) => {
              commit("failed", { error });

              reject(error);
            });
        });
      },
      import(
        { commit, getters },
        {  }
      ) {
        commit("loading");

        return new Promise((resolve, reject) => {
          this.$axios
            .post(`/${name}/edit_csv/import`, {
              file: getters.file
            })
            .then((response) => {
              commit("succeeded", {
                entities: response.data.data,
                total: response.data.total
              });

              resolve(response);
            })
            .catch((error) => {
              commit("failed", { error });

              reject(error);
            });
        });
      },
      exec({ commit, getters }, { }) {
        const store = this;

        commit("processing");

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .put(`/${name}/edit_csv/exec`, { entities: getters.entities})
            .then(() => {
              commit("processed");

              utility.$message({
                type: "success",
                message: "一括登録が完了しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      },
      download({ commit, getters }, { selected }) {
        const store = this;

        commit("processing");

        return new Promise((resolve, reject) => {
          store.$axios // axios
            .post(`/${name}/edit_csv/download`, {
              entities: selected
            }, {
              responseType: "blob"
            })
            .then((response) => {
              commit("processed");

              if (response.data.size) {
                let blob = new Blob([response.data], { type: "application/csv" });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = `import_${name}.csv`;
                link.click();
              } else {
                utility.$message({
                  type: "warning",
                  message: "ファイルが存在しません。",
                  showClose: true,
                  customClass: "el-message-content-position"
                });
              }

              utility.$message({
                type: "success",
                message: "一括編集CSVを出力しました",
                showClose: true,
                customClass: "el-message-content-position"
              });

              resolve();
            })
            .catch((error) => {
              commit("processed");
              commit("failed", { error });

              reject(error);
            });
        });
      }
    },
    getters: {
      entities(state) {
        return state.entities || [];
      },
      total(state) {
        return state.total || 0;
      },
      isLoading(state) {
        return state.loading;
      },
      isLoaded(state) {
        return state.loaded;
      },
      isProcessing(state) {
        return state.processing;
      },
      file(state) {
        return state.file || null;
      },
      open(state) {
        return state.open;
      },
      selected(state) {
        return state.selected || [];
      },
      allSelected(state) {
        return state.allSelected;
      },
      errorMessages(state) {
        return state.errorMessages || [];
      }
    }
  };
};
